import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { TornEdge } from './TornEdge';
import { Reveal } from './Reveal';
import { PolaroidVideo } from './PolaroidVideo';
import { testimonials } from '../data/testimonials';
import { testimonialVideoSrc } from '../data/media';
export function Testimonials() {
  return <section aria-labelledby="testimonios-title" className="relative bg-ink py-20 sm:py-28" data-id="element-191" data-mp="3ayqdxfee6t31">
      <TornEdge colorClassName="bg-ink" data-id="element-192" data-mp="31zw8czj32sdc" />
      <div className="relative mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-193" data-mp="31yuw4rqbzzu1">
        <Reveal data-id="element-194" data-mp="2x0jqkt72kbhm">
          <SectionHeading id="testimonios-title" folio="Sección V · Anexos" title="Experiencias de Nuestros Clientes" data-id="element-195" data-mp="2x007381rtf1h" />
        </Reveal>

        <Reveal className="mt-14" data-id="element-196" data-mp="v9yghcqvjxas">
          <PolaroidVideo src={testimonialVideoSrc} caption="Experiencia compartida por un cliente, publicada con su autorización." tiltClassName="rotate-[1.2deg]" data-id="element-197" data-mp="v8555k5bgowg" />
        </Reveal>

        <Reveal className="mt-12" stamp data-id="element-198" data-mp="h818fqfnqklj">
          <div className="mx-auto max-w-2xl border border-dashed border-gold/70 bg-plum-deep/60 p-8 text-center" data-id="element-199" data-mp="m5b59r5dlyje">
            <QuoteIcon className="mx-auto h-6 w-6 text-gold" aria-hidden="true" data-id="element-200" data-mp="78ttwzx6sjwu" />
            <p className="mt-5 text-[0.95rem] leading-relaxed text-body sm:text-base" data-id="element-201" data-mp="c6bwm8km22we">
              En esta sección publicamos únicamente experiencias reales
              compartidas por nuestros clientes, con su autorización previa.
            </p>
          </div>
        </Reveal>

        {testimonials.length > 0 ? <ul className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-202" data-mp="q5v0gp6e2s2w">
            {testimonials.map((testimonial, index) => <Reveal as="li" key={`${testimonial.name}-${testimonial.quote.slice(0, 12)}`} delay={index * 0.08} data-id="element-203" data-mp="v3mr7fvas85i" data-mpi={index}>
                <figure className="flex h-full flex-col border border-gold/30 bg-plum-deep/60 p-7" data-id="element-204" data-mp="1nnlbehsso6rd">
                  <blockquote className="flex-1 text-sm leading-relaxed text-body sm:text-[0.95rem]" data-id="element-205" data-mp="1xhh841b51lob">
                    {testimonial.quote}
                  </blockquote>
                  <figcaption className="mt-6 border-t border-gold/25 pt-5 font-folio text-[0.65rem] uppercase tracking-[0.2em] text-gold" data-id="element-206" data-mp="1og9kcd69038h">
                    {testimonial.name}
                    {testimonial.city ? <span className="block pt-1 text-body/70" data-id="element-207" data-mp="1ekpofqrop4jq">
                        {testimonial.city}
                      </span> : null}
                  </figcaption>
                </figure>
              </Reveal>)}
          </ul> : null}
      </div>
    </section>;
}